import { writable } from 'svelte/store';
import { allInfrastructures, allMaterials, allPipeSizes } from '../scripts/wpn2Model.js';
import { index } from 'd3';

const mapPreferences = writable({
    mapInstance: null,
    infrastructures: ["Water"],
    categories: ["assets", "nhm", "alfx-heat-map", "utility"],
    modeDrawPipe: "infrastructure",
    modeColorMap: "on",
    showServices: "on",
    default: {
        infrastructures: ["Water"],
        categories: ["assets", "nhm", "alfx-heat-map", "utility"],
        modeDrawPipe: "infrastructure",
        modeColorMap: "on",
        showServices: "on"
    }
});

const mapPrefs = {
    subscribe: mapPreferences.subscribe,
    setMapInstance: (data) => {
        mapPreferences.update((prefs) => {
            prefs.mapInstance = data;
            return prefs;
        });
    },
    updateInfrastructures: (data) => {
        mapPreferences.update((prefs) => {
            prefs.infrastructures = data;
            return prefs;
        });
    },
    updateCategories: (data) => {
        mapPreferences.update((prefs) => {
            prefs.categories = data;
            return prefs;
        });
    },
    updateModeDrawPipe: (mode) => {
        mapPreferences.update((prefs) => {
            prefs.modeDrawPipe = mode;
            return prefs;
        });
    },
    updateModeColorMap: (mode) => {
        mapPreferences.update((prefs) => {
            prefs.modeColorMap = mode;
            return prefs;
        });
    },
    updateModeShowServices: (mode) => {
        mapPreferences.update((prefs) => {
            prefs.showServices = mode;
            return prefs;
        });
    },
    setDefault: () => {
        mapPreferences.update((prefs) => {
            prefs.infrastructures = prefs.default.infrastructures;
            prefs.categories = prefs.default.categories;
            prefs.modeDrawPipe = prefs.default.modeDrawPipe;
            prefs.modeColorMap = prefs.default.modeColorMap;
            prefs.showServices = prefs.default.showServices;
            return prefs;
        });
    },
    allPipeDrawingModes: () => {
        return [
            { mode: 'infrastructure', title: "Infrastructure", values: allInfrastructures(), index: 0 },
            { mode: 'material', title: "Material", values: allMaterials(), index: 1 },
            { mode: 'size', title: "Size", values: allPipeSizes(), index: 2 },
            { mode: 'hidden', title: "Hidden", values: [], index: 3 }
        ];
    },
    valuesForPipeDrawingMode: (mode) => {
        return mapPrefs.allPipeDrawingModes().find((x) => x.mode === mode)?.values ?? [];
    },
    allColorMapModes: () => {
        return ['on', 'off'];
    },
};

export default mapPrefs;
